module.exports = __webpack_public_path__ + "img/24.06b76033.jpg";